import React, { Fragment, useState, useEffect } from "react";
import schedule_icon from "../../assets/media/token_earning/wall-clock.png";
import moment from "moment";
const PostDetail = ({
  post,
  users,
  brand_name,
  onDecline,
  onAccept,
  onPostNow,
  onEdit,
  hex,
  white,
}) => {
  const [publishForText, setPublishForText] = useState("");

  useEffect(() => {
    if (post.toMembers === undefined || post.toMembers === true) {
      if (post.toReferrals === undefined || post.toReferrals === true) {
        setPublishForText("Published for customers and prospects.");
      } else {
        setPublishForText("Published for customers.");
      }
    } else {
      if (post.toReferrals === undefined || post.toReferrals === true) {
        setPublishForText("Published for prospects.");
      }
    }
  }, [post]);

  function getPostingTime(post) {
    if (post.postNow) {
      const date = moment.unix(post.timestamp.seconds);
      return date.format("LLL");
    } else {
      const date = moment(post.scheduledDate);
      return date.format("LLL");
    }
  }
  function isPostLive(post) {
    if (post.postNow || post.hot_topic) {
      return true;
    } else {
      const date = moment(post.scheduledDate);
      if (moment().isAfter(date)) return true;
      else return false;
    }
  }
  function getPostedBy(post) {
    const user = users.find((item) => item.id === post.uid);
    if (user) {
      return `${user.firstname} ${user.lastname || ""}`;
    }

    return "Unknown";
  }

  function getStatusText() {
    if (post.firstname) {
      return post.accepted || post.hot_topic ? "Live" : "Declined";
    } else {
      return post.postNow ? "Live" : "Pending";
    }
  }
  return (
    <Fragment>
      <div className="details">
        <p className="time">
          {isPostLive(post) ? "Posted at " : "Scheduled at "}
          {getPostingTime(post)}
        </p>
        <p>Posted By {post.from_admin ? brand_name : getPostedBy(post)}</p>
        {post.accepted === "" && !post.hot_topic ? (
          <div className="action-container">
            <button className="btn btn-danger" onClick={onDecline(post)}>
              Decline
            </button>
            <button className="btn btn-primary" onClick={onAccept(post)}>
              Accept
            </button>
          </div>
        ) : (
          <Fragment>
            <p className={`accept-status ${getStatusText()}`}>
              {getStatusText()}
              {!isPostLive(post) && (
                <img
                  src={schedule_icon}
                  width="20"
                  height="20"
                  style={{ marginLeft: 10 }}
                />
              )}
            </p>
            {!isPostLive(post) && (
              <button
                className="btn btn-green"
                style={{
                  marginRight: 24,
                  fontSize: 12,
                  padding: "6px 12px",
                  fontSize: 16,
                  fontWeight: 600,
                }}
                onClick={onPostNow(post)}
              >
                Post Now
              </button>
            )}
          </Fragment>
        )}
        <button
          className="btn btn-white btn-brand-hex"
          style={{
            backgroundColor: "white",
            color: "black",
            "--hover-text-color": white ? "white" : "black",
            "--hover-color": hex || "white",
          }}
          onClick={onEdit}
        >
          Edit
        </button>
      </div>
      <div style={{ width: "40%" }}>
        <p className="title">{post.title}</p>
        <p className="sub-title overflow-ellipsis">{post.content}</p>
        <p className="sub-title">
          <b>Topic:</b> {post.topic}
        </p>
        <p className="sub-title">
          <b>Type:</b> {post.type}
        </p>
        <p className="publish-for">{publishForText}</p>
      </div>
    </Fragment>
  );
};
export default PostDetail;



// WEBPACK FOOTER //
// ./src/screens/Feeds/PostDetail.js